import Manager from "../../src/manager";
import React from "react";
import Functions from "../../src/functions";

function Mapper(data, status, response, error, component) {
	let output = [];
	let UserType = Functions["custom"]["getUserType"]();

	if (
		UserType === "POSTB" ||
		UserType === "POSTB_SPLIT" ||
		UserType === "POSTR"
	) {
		if (data) {
			let property = {};
			// property["modal"] = itm.serviceTitle;
			property["nextBillingDate"] = data.item;
			property["showNextUpdate"] = data.item.totalRemainingMB;

			property["showTerms"] = data.item.totalRemainingMB;
			property["showTermVat"] = data.item.totalRemainingMB;

			output.push(property);
		}
	}
	return output;
}

function Properties(args) {
	let editable = args.editable ? true : false;
	return {
		nextBillingDate: {
			alias: "nextBillingDate",
			type: "text",
			editable,
		},
		showNextUpdate: {
			alias: "showNextUpdate",
			type: "text",
			label: "",
			placeholder: "",
			useCustomUI: true,
			customUI: function () {
				let data = this.props.data;
				return (
					<>
						<div>
							{data.item !== "" || data.item !== null ? (
								<div
									className="next-update"
									id="next-update-visible"
									style={{ display: "block" }}>
									Τα δωρεάν MB <span rechargepackagetype=""></span> θα
									ανανεωθούν αυτόματα στις
									<span className="white-space-now-wrap">
										{" "}
										{" " + data.nextBillingDate}
									</span>
								</div>
							) : null}
						</div>
					</>
				);
			},
		},
		showTerms: {
			alias: "showTerms",
			type: "text",
			label: "",
			placeholder: "",
			useCustomUI: true,
			customUI: function () {
				let data = this.props.data;
				let _this = this;
				return (
					<div
						className="hold"
						style={{
							display: "flex",
							flexDirection: "column",
							justifyContent: "center",
						}}>
						<a
							className="terms open-lightbox"
							style={{ cursor: "pointer", lineHeight: "30px" }}
							onClick={(e) => clickMeTerm(_this)}>
							Όροι &amp; Προϋποθέσεις &gt;{" "}
						</a>
						<a
							className="terms open-lightbox"
							style={{ cursor: "pointer", lineHeight: "30px" }}
							onClick={(e) => clickMeAccessibilityStatement()}>
							Δήλωση Προσβασιμότητας &gt;{" "}
						</a>
					</div>
				);
			},
		},
		showTermVat: {
			alias: "showTermVat",
			type: "text",
			label: "",
			placeholder: "",
			useCustomUI: true,
			customUI: function () {
				let data = this.props.data;
				let _this = this;
				let UserType = Functions["custom"]["getUserType"]();
				let landPageData = JSON.parse(sessionStorage.landPageData);
				if (
					(UserType === "POSTR" ||
						UserType === "POSTB_SPLIT" ||
						UserType === "POSTB") &&
					landPageData.contractInfoCarrier.inListOfWhatuspCss
				) {
					return (
						<div className="home-links">
							<div className="next-update vat">
								Τιμές με ΦΠΑ και&nbsp;
								<a
									style={{ cursor: "pointer" }}
									onClick={(e) => clickMeTermVat(_this)}
									className="terms open-lightbox termvat">
									Τέλος Συνδρομητών Κινητής Τηλεφωνίας
								</a>
								&nbsp;10%, όπου αυτό εφαρμόζεται.
							</div>
						</div>
					);
				} else {
					return (
						<div>
							<div className="terms next-update vat ">
								Τιμές με ΦΠΑ και&nbsp;
								<a
									style={{ cursor: "pointer" }}
									onClick={(e) => clickMeTermVat(_this)}
									className="terms open-lightbox termvat">
									Τέλος Συνδρομητών Κινητής Τηλεφωνίας
								</a>
								&nbsp;10%, όπου αυτό εφαρμόζεται.
							</div>
						</div>
					);
				}
			},
		},
	};
}

function clickMeTerm(_this) {
	let id = _this.props.primaryKey;
	let manager = _this.props.manager;
	window["modal"].setState({
		// title: <h4>Confirm deletion</h4>,
		targetComponent: this,
		show: true,
		callback: function (args) {
			window["modal"].setState({ show: false });
			setTimeout(manager.refresh, 2000);
		},
		// footer: [],
		body: (
			<Manager
				key="modalForTerms"
				module="modalForTerms"
				data={_this.props.data}
				view="list"
				ref={(refComponent) => {
					window["modalbody"] = refComponent;
				}}></Manager>
		),
	});
}

function clickMeAccessibilityStatement() {
	window.open("./resources/pdf/accessibility-statement.html", "_blank");
}

function clickMeTermVat(_this) {
	let id = _this.props.primaryKey;
	let manager = _this.props.manager;
	window["modal"].setState({
		// title: <h4>Confirm deletion</h4>,
		targetComponent: this,
		show: true,
		callback: function (args) {
			window["modal"].setState({ show: false });
			setTimeout(manager.refresh, 2000);
		},
		// footer:[],
		body: (
			<Manager
				key="modalForTermVat"
				module="modalForTermVat"
				data={_this.props.data}
				view="list"
				ref={(refComponent) => {
					window["modalbody"] = refComponent;
				}}></Manager>
		),
	});
}

const Footer = {
	auth: "",
	views: {
		list: {
			apis: {
				view: {
					url: "{path}",
					method: "POST",
					replace: {
						path: function () {
							let random = new Date().getTime();

							let landPageData = JSON.parse(sessionStorage.landPageData);

							if (
								landPageData.contractInfoCarrier.customerSegment === "POSTB" ||
								landPageData?.contractInfoCarrier?.customerSegment ===
									"POSTB_SPLIT" ||
								landPageData.contractInfoCarrier.customerSegment === "POSTR"
							) {
								return "/service/getNextBillingDate?t=".concat(random);
							} else {
								return "";
							}
						},
					},
					mapper: Mapper,
				},
			},
			template: "footer",
			templateConfiguration: {
				includeProperties: [],
				excludeProperties: [],
				events: { onClick: function (e) {} },
			},
			properties: Properties({ editable: false }),
			primaryKey: "id",
		},
	},
};

export default Footer;
